import React, { useEffect, useState } from 'react';
import { makeStyles, Container, Grid } from '@material-ui/core';
import {
  BackNavAdmin,
  CurationTitle,
  CurationTable,
  CurantionCardsStatus,
  CurationMenus,
  CurationMenusTable,
  CurationCard,
  Loading,
  CurationFilters
} from '../../components';
import InfiniteScroll from 'react-infinite-scroll-component';
import { curationActions, ideaActions } from '../../actions';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../../hooks';
import config from '../../config';

import ideaIcon from '../../assets/imgs/ideiaPurple.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(4),
  },
}));

function CurationIdeasMatPage(props) {
  const classes = useStyles();
  const [width] = useWindowSize();
  const dispatch = useDispatch();
  const {
    ideas,
    paging,
    loading,
    paging: { statusCode, page, sort, query, limit },
    filters
  } = useSelector((state) => state.curation);
  const { t } = useTranslation();
  const [tabChosed, setTabChosed] = useState('AWAITING_QUALIFICATION');

  useEffect(() => {
    dispatch(curationActions.setStatusToFilter('AWAITING_QUALIFICATION'));
  }, []);

  useEffect(() => {
    dispatch(curationActions.clearFiltersNotStatus());
    dispatch(curationActions.filterIdeas({...filters, statusCode: [tabChosed]}));
    dispatch(ideaActions.getStatusIdeas());
  }, [tabChosed]);

  const handleChangeTab = (tabView) => {
    switch (tabView) {
      case 'AWAITING_QUALIFICATION':
        setTabChosed('AWAITING_QUALIFICATION');
        dispatch(curationActions.setStatusToFilter('AWAITING_QUALIFICATION'));
        return;
      case 'EXECUTION_QUEUE':
        setTabChosed('EXECUTION_QUEUE');
        dispatch(curationActions.setStatusToFilter('EXECUTION_QUEUE'));
        return;
      case 'EXECUTING':
        dispatch(curationActions.setStatusToFilter('EXECUTING'));
        setTabChosed('EXECUTING');
        return;
      default:
        setTabChosed('AWAITING_QUALIFICATION');
    }
  }

  function loadMoreIdeas() {
    if (!loading) {
      var newPage = page === 1 ? 2 : page;

      dispatch(
        curationActions.getIdeasMobile(
          newPage,
          sort,
          query,
          limit,
          [tabChosed],
        )
      );
    }
  }


  function renderTable() {
    return (
      <>
        {ideas?.length > 0 && <CurationTable ideas={ideas} paging={paging} loading={loading} />}
      </>
    );
  }

  function renderCards() {
    if (ideas?.length > 0) {
      return (
        <InfiniteScroll
          dataLength={ideas.length}
          next={loadMoreIdeas}
          hasMore={true}
          scrollThreshold={'100%'}
          loader={
            loading && (
              <div className={classes.containerLoading}>
                <Loading />
              </div>
            )
          }
        >
          {ideas.map((ideas, index) => (
            <CurationCard
              key={index}
              index={index}
              ideas={ideas}
            />
          ))}
        </InfiniteScroll>
      );
    }

    return null;
  }

  return (
    <>
      <BackNavAdmin title={t('curadoria')} />
      <Container maxWidth="lg" className={classes.root}>
        <CurationMenus />
        <CurationTitle
          title={t('esteira_de_ideias')}
          icon={<img src={ideaIcon} alt="idea icon" style={{ width: 27 }} />}
          info={t('as_ideias_na_esteira_necessitam_de_acoes_do_gestor_para_avancar_para_os_proximos_status')}
        />
        <CurantionCardsStatus />
        <CurationFilters statusCode={statusCode} paging={paging} />
        <CurationMenusTable tabChosed={tabChosed} handleChangeTab={handleChangeTab} />
        <Grid container>
          <Grid item xs={12}>
            {width > config.RESPONSIVE_MOBILE ? renderTable() : renderCards()}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export { CurationIdeasMatPage };
